/* 🤖 this file was generated by svg-to-ts */
export const matIconAddModerator: {
  name: 'add-moderator';
  data: string;
} = {
  name: 'add-moderator',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M6 11.09v-4.7l6-2.25 6 2.25v3.69c.71.1 1.38.31 2 .6V5l-8-3-8 3v6.09c0 5.05 3.41 9.76 8 10.91.03-.01.05-.02.08-.02-.79-.78-1.4-1.76-1.75-2.84C7.76 17.53 6 14.42 6 11.09z"/><path d="M17 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm3 5.5h-2.5V20h-1v-2.5H14v-1h2.5V14h1v2.5H20v1z"/></svg>`
};
